<template>
  <v-row class="mx-auto">
    <v-col
      v-for="(article, key) in articles"
      :key="`article_${key}`"
      class="align-stretch px-2"
      cols="12"
      sm="6"
      md="4"
    >
      <v-card
        style="height: 100%;"
        @click="openLink(article.link)"
      >
        <v-card-text
          class="d-flex flex-column justify-space-between"
          style="height: 100%;"
        >
          <!-- Image -->
          <v-img
            style="max-width: 100%;"
            :src="article.img"
            aspect-ratio="2.35"
            :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
          >
            <template #placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                />
              </v-row>
            </template>
          </v-img>

          <!-- Title -->
          <div class="py-3">
            <h3>{{ article.title }}</h3>
          </div>

          <!-- Link -->
          <v-btn
            color="primary lighten-2"
            style="width: 100%;"
          >
            Read Article
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Articles',

  data: () => ({
    articles: [
      {
        title: '3 Factors That Matter Most to Clients',
        link: 'https://globalcoachgroup.com/coach-insights/3-client-needs/',
        img: 'https://cdn.sccoaching.com/static/images/article/article_6.png',
      },
      {
        title: 'The Step-by-Step Guide to Securing Higher-Paying Clients',
        link: 'https://globalcoachgroup.com/coach-insights/higher-paying-clients/',
        img: 'https://cdn.sccoaching.com/static/images/article/article_3.png',
      },
      {
        title: '5 Marketing Tips for Executive Coaches',
        link: 'https://globalcoachgroup.com/coach-insights/5-marketing-tips-for-executive-coaches/',
        img: 'https://cdn.sccoaching.com/static/images/article/article_4.png',
      },
      {
        title: '7 Strategies for Securing More Coaching Clients',
        link: 'https://globalcoachgroup.com/coach-insights/secure-clients-strategies/',
        img: 'https://cdn.sccoaching.com/static/images/article/article_2.png',
      },
      {
        title: 'How to Leverage 360 Assessment Tools to Coach Leaders',
        link: 'https://globalcoachgroup.com/coach-insights/360-tools/',
        img: 'https://cdn.sccoaching.com/static/images/article/article_5.png',
      },
      {
        title: 'The Impact of Digitization and Technology on Leadership',
        link: 'https://globalcoachgroup.com/coach-insights/the-impact-of-digitization-and-technology-on-leadership/',
        img: 'https://cdn.sccoaching.com/static/images/article/article_1.png',
      },
    ],
  }),

  methods: {
    openLink(link) {
      window.open(link, '_blank');
    },
  },
};
</script>
